import { Exclude } from 'class-transformer';
import { BaseItem } from './base-item.model';

export enum UserPermissions {
  manage_all = 'manage all', // super-admin
  manage_users = 'manage users',
  settings_access = 'settings access',
  access_all_locations = 'access all location',
  donation_access = 'donation access',
  send_bulk_emails_to_all_contacts = 'send bulk emails to all contacts',
  send_bulk_emails_to_course_attendees_per_course = 'send bulk emails to course attendees per-course'
}

interface PermissionAttributes {
  name: string;
  guard_name: string;
  created_at: string;
  updated_at: string;
}

@Exclude()
export class Permission extends BaseItem<PermissionAttributes> {}
